
    module.exports = {
        LPD_banner: require('./LPD_banner.png'),
        IMG_banner: require('./image_banner.png'),
        MREC_banner: require('./Mrec_banner.png')
    };
